// extracted by mini-css-extract-plugin
export default {"main_container":"Demo_main_container__KRxyw","heading_text":"Demo_heading_text__ASU2f","center_card":"Demo_center_card__W5wAC","bottomSignup":"Demo_bottomSignup__Ws6t8"};